<template>
    <div class="table-responsive">
        <table class="table table-border">
            <thead>
                <tr>
                    <th scope="col">Expenses and Payments</th>
                    <th scope="col">B/L {{year-1}} </th>
                    <th v-bind:class="{'active-month': currentMonth == 1}"  scope="col">Jan</th>
                    <th v-bind:class="{'active-month': currentMonth == 2}"  scope="col">Feb</th>
                    <th v-bind:class="{'active-month': currentMonth == 3}"  scope="col">Mar</th>
                    <th v-bind:class="{'active-month': currentMonth == 4}"  scope="col">Apr</th>
                    <th v-bind:class="{'active-month': currentMonth == 5}"  scope="col">May</th>
                    <th v-bind:class="{'active-month': currentMonth == 6}"  scope="col">Jun</th>
                    <th v-bind:class="{'active-month': currentMonth == 7}"  scope="col">Jul</th>
                    <th v-bind:class="{'active-month': currentMonth == 8}"  scope="col">Aug</th>
                    <th v-bind:class="{'active-month': currentMonth == 9}"  scope="col">Sep</th>
                    <th v-bind:class="{'active-month': currentMonth == 10}" scope="col">Oct</th>
                    <th v-bind:class="{'active-month': currentMonth == 11}" scope="col">Nov</th>
                    <th v-bind:class="{'active-month': currentMonth == 12}" scope="col">Dec</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="propertyFee, key, index in propertyFees">
                    <td scope="row"> <strong>Monthly Rate</strong></td>
                    <td v-bind:class="{'active-month-column': currentMonth == (key2 )}" v-for="fee, key2 in propertyFee.fees">
                        <div v-if="key2  <= 12">
                            <div v-if="key2 > currentMonth">
                                -
                            </div>
                            <div v-else>
                                <div v-if="key2  < currentMonth && key2  > 0">
                                    <div v-if="fee == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        {{ $filters.toCurrency(fee) }}
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="fee == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        {{ $filters.toCurrency(fee) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="fee == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(fee) }}
                            </div>
                        </div>
                    </td>
                    <td></td>
                </tr>
                <tr v-for="additionalExpense, key, index in additionalExpenseFees">
                    <td scope="row"> <strong>Additional Expenses</strong></td>
                    <td v-bind:class="{'active-month-column': currentMonth == (key4 )}" v-for="fee2, key4 in additionalExpense.fees">
                        <div v-if="key3  <= 12">
                            <div v-if="key3 > currentMonth">
                                -
                            </div>
                            <div v-else>
                                <div v-if="key4 <= currentMonth && key4 > 0">
                                    <div v-if="fee2 == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        {{ $filters.toCurrency(fee2) }}
                                    </div>
                                </div>
                                <div v-else>
                                    <a> - </a>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="fee2 == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(fee2) }}
                            </div>
                        </div>
                    </td>
                    <td></td>
                </tr>
                <!-- <tr >
            <td> <strong>Total</strong></td>
            <td v-for="expensesSum,key4 in expensesTotal">
            <div v-if="key4 <= 12">
                <div v-if="key4  > currentMonth">
                    <a > - </a>
                </div>
                <div v-else>
                    <div v-if="key4  < currentMonth && key4  > 0">
                        <div v-if="expensesSum == 0">
                            -
                        </div>
                        <div v-else>
                            {{ expensesSum.toFixed(2) }}
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="expensesSum == 0">
                            -
                        </div>
                        <div v-else>
                            {{ expensesSum.toFixed(2) }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="expensesSum == 0">
                    -
                </div>
                <div v-else>
                    {{ expensesSum.toFixed(2) }}
                </div>
            </div>
        </td>
    </tr> -->

                <tr v-for="payment, key, index in payments">
                    <td scope="row"> <strong>Payments done</strong></td>
                    <td v-bind:class="{'active-month-column': currentMonth == (key3 )}" v-for="fee2, key3 in payment.fees">
                        <div v-if="key3  <= 12">
                            <div v-if="key3 > currentMonth">
                                -
                            </div>
                            <div v-else>
                                <div v-if="key3 <= currentMonth && key3 > 0">
                                    <div v-if="fee2 == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        <router-link :to="{name: (owner == false ? 'payments' : 'paymentsowner'), params: { propertyId: (owner ==true ? propertyId : unitId), buildingId:buildingId, buildingName:buildingName,month:key3,year:year}}"> {{ $filters.toCurrency(fee2) }}</router-link>
                                    </div>
                                </div>
                                <div v-else>
                                    <a> - </a>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="fee2 == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(fee2) }}
                            </div>
                        </div>
                    </td>
                    <td></td>
                </tr>

                <tr v-for="payment, key, index in creditNotes">
                    <td scope="row"> <strong>Credit Notes</strong></td>
                    <td v-bind:class="{'active-month-column': currentMonth == (key3 )}" v-for="fee2, key3 in payment.fees">
                        <div v-if="key3  <= 12">
                            <div v-if="key3 > currentMonth">
                                -
                            </div>
                            <div v-else>
                                <div v-if="key3 <= currentMonth && key3 > 0">
                                    <div v-if="fee2 == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        <router-link :to="{name: (owner == false ? 'payments' : 'paymentsowner'), params: { propertyId: (owner ==true ? propertyId : unitId), buildingId:buildingId, buildingName:buildingName,month:key3,year:year}}"> {{ $filters.toCurrency(fee2) }}</router-link>
                                    </div>
                                </div>
                                <div v-else>
                                    <a> - </a>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="fee2 == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(fee2) }}
                            </div>
                        </div>
                    </td>
                    <td></td>
                </tr>

                <tr>
                    <td scope="row">
                        <strong>Balance</strong>
                    </td>
                    <td v-bind:class="{'active-month-column': currentMonth == (key4 )}" v-for="total,key4 in totalFees">
                        <div v-if="key4 <= 12">
                            <div v-if="key4  > currentMonth">
                                <a> - </a>
                            </div>
                            <div v-else>
                                <div v-if="key4  < currentMonth && key4  > 0">
                                    <div v-if="total == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        {{ $filters.toCurrency(total) }}
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="total == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        {{ $filters.toCurrency(total) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="total == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(total) }}
                            </div>
                        </div>
                    </td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["route", "period", "owner", "unitId"],
  data: function () {
    return {
      propertyFees: [],
      totalFees: [],
      additionalExpenseFees: [],
      expensesTotal: [],
      index: 0,
      isModalVisible: true,
      monthParam: 0,
        payments: [],
        creditNotes: [],
      year: 0,
      currentMonth: 0,
    };
  },
  watch: {
    value(val) {
      this.$emit("update:propertyId", val);

    },
    value2(val) {
      this.$emit("update:unitId", val);

    },
    propertyId(val) {
      this.value = val;
      this.fetchStatement();
    },
    unitId(val){
        this.value2 = val;
        this.fetchStatement();
    }
  },

  mounted() {
    if (!this.$period.isCurrent(this.period)) {
      this.currentMonth = 12;
      this.year = new Date().getFullYear() - (Number(this.period) - 1);
    } else {
      this.year = new Date().getFullYear();
      this.currentMonth = new Date().getMonth() + 1;
    }

     this.fetchStatement();
    //this.propertyHistory = JSON.parse(this.propertyAttribute)

    //console.log(this.propertyAttribute)
    //this.propertyHistory = this.propertyAttribute
  },

  methods: {
    beforeOpen(event) {
      this.propertyId = event.params.creditortypeid;
      this.monthParam = event.params.month + 1;
    },
    showModal() {
      this.isModalVisible = true;
      alert(this.isModalVisible);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    fetchStatement: function () {
      var request = "/statement/userstatement";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + (this.owner ? this.propertyId : this.unitId) + "&period=" + this.period;
      /*  if(this.period == 2)	
                    request = request +'/'+this.period;
                else
                    request = request +'?id='+this.buildingId;*/

      this.$http
        .get(request, {
          id: (this.owner ? this.propertyId : this.unitId),
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.propertyFees = data.propertyFees;
          this.totalFees = data.totalFees;
            this.payments = data.paymentFees;
            this.creditNotes = data.creditNoteFees;
          this.additionalExpenseFees = data.additionalExpenseFees;
        });
    },

    show() {
      // this.$modal.show('creditors-form');
    },
    hide() {
      // this.$modal.hide('creditors-form');
    },

    /**
     * Prepare the component.
     */
  },

  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      property:(state)=>state.property.currentProperty,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.property != null && this.property!= undefined && this.owner)
        return  this.property.buildingName;
    if(this.building != null && this.building!= undefined)
    return  this.building.name;
      return ""
    },
    buildingId(){
        if(this.property != null && this.property!= undefined && this.owner)
        return  this.property.buildingId;
        if(this.building != null && this.building!= undefined)
    return  this.building.id;
      return ""
    },
    propertyId(){
      if(this.property != null)
        return  this.property.id;
      return ""
    },
    propertyName(){
      if(this.property != null)
        return  this.property.propertyName;
      return ""
    },
    total: function () {
     return this.propertyFees[0].reduce(function (total, fees) {
        return total + fees[0];
      }, 0);
    },

    // expensesSum: function(){

    // }
  },
}; // Our Javascript logic
</script>
